import { Container, Row, Col, Button, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
// import styles from './Home.module.css'; // Optional CSS for custom styling
import cabImage from '../../assets/hero-bg.png'; // Replace with your image path

const Home = () => {
  return (
    <div>

      {/* Hero Section */}
      {/* <div className={`bg-light text-center py-5`}>
        <Container>
            <img src={cabImage} alt="Cab" className="img-fluid rounded" />
        </Container>
      </div> */}

      {/* About Section */}
      <Container className="my-5">
        <Row className="align-items-center">
          <Col md={6}>
            <img src={cabImage} alt="Cab" className="img-fluid rounded" />
          </Col>
          <Col md={6}>
            <h2>About Rave Cabs</h2>
            <p>
              We are a Jaipur-based premium cab service provider offering 24/7 transportation with professional drivers and clean, GPS-enabled cars. Whether it’s a daily commute or an outstation trip, trust Rave Cabs for safe travel.
            </p>
          </Col>
        </Row>
      </Container>

      {/* Services Overview */}
      <Container className="my-5 text-center">
        <h2 className="mb-4">Our Services</h2>
        <Row>
          <Col md={4}>
            <Card className="mb-4 shadow-sm">
              <Card.Body>
                <Card.Title>City Rides</Card.Title>
                <Card.Text>Quick and reliable rides across the city at competitive prices.</Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4}>
            <Card className="mb-4 shadow-sm">
              <Card.Body>
                <Card.Title>Outstation Trips</Card.Title>
                <Card.Text>Enjoy long-distance comfort with experienced drivers and sanitized cabs.</Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4}>
            <Card className="mb-4 shadow-sm">
              <Card.Body>
                <Card.Title>Corporate Travel</Card.Title>
                <Card.Text>On-time pickup and drop with billing support for corporate clients.</Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>

      {/* Why Choose Us */}
      <Container fluid className="bg-light py-5">
        <Container>
          <h2 className="text-center mb-4">Why Choose Rave Cabs?</h2>
          <Row>
            <Col md={6}>
              <ul>
                <li>✔️ 24/7 Availability</li>
                <li>✔️ Trained Drivers</li>
                <li>✔️ Well-maintained Fleet</li>
              </ul>
            </Col>
            <Col md={6}>
              <ul>
                <li>✔️ Affordable Pricing</li>
                <li>✔️ GPS Tracking</li>
                <li>✔️ Customer Support</li>
              </ul>
            </Col>
          </Row>
        </Container>
      </Container>

      {/* Contact/CTA Section */}
      <Container className="text-center py-5">
        <h2>Ready to Ride with Us?</h2>
        <p>Call us at <strong>+91-8239839490</strong> or email <strong>ravecabs.care@gmail.com</strong></p>
        <Button as={Link as any} to="/contact-us" size="lg" variant="primary">
          Contact Us
        </Button>
      </Container>

    </div>
  );
};

export default Home;